<template lang="pug">
  game-preview-settings
    game-preview-setting
      span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
      span(slot="value") {{ $i18n.t('common.common_gameName_cosmoTour') }}
    game-preview-setting
      span(slot="name") {{ 'Количество планет' }}
      span(slot="value") {{ settings.amountOfPlanets }}
    game-preview-setting
      span(slot="name") {{ 'Тип примеров' }}
      span(slot="value") {{ typeName }}
    game-preview-setting
      span(slot="name") {{ 'Длительность игры' }}
      span(slot="value") {{ settings.gameDuration.label }}
    template(v-if="settings.complication.selected")
        game-preview-setting
          span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_exampleComplication') }}
          span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
        game-preview-setting
          span(slot="name") {{ 'Количество шагов' }}
          span(slot="value") {{ settings.complication.steps }}
    template(v-else)
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_exampleComplication') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_off') }}
    template(v-if="settings.distraction")
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_distractingPictures') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
    template(v-else)
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_distractingPictures') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_off') }}
    template(v-if="settings.tip")
        game-preview-setting
            span(slot="name") {{ 'Подсказка' }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
    template(v-else)
        game-preview-setting
            span(slot="name") {{ 'Подсказка' }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_off') }}
</template>

<script>

    import GamePreviewSettings from './GamePreviewSettings.vue';
    import GamePreviewSetting from './GamePreviewSetting.vue';
    import GamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';

    export default {
        props: ['parameters', 'exerciseId', 'type'],
        mixins: [GamePreviewMixin],
        components: {
            GamePreviewSettings,
            GamePreviewSetting,
        },
        computed: {
            typeName() {
                switch (this.settings.type.value) {
                    case 'digits':
                        return 'Цифры';
                    case 'colors':
                        return 'Цвета';
                    case 'mixed':
                        return 'Смешанный';
                    default:
                        return '';
                }
            },
        },
    };
</script>
